var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-action-buttons" }, [
    _c("div", [
      _vm.showPrevBtn()
        ? _c(
            "button",
            {
              staticClass: "c-action-buttons__button",
              attrs: {
                disabled: _vm.prevDisabled,
                type: _vm.prevType,
                tabindex: _vm.prevDisabled ? -1 : 0
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handlePrevButtonClick()
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.prevLabel) + "\n    ")]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.showNextBtn()
        ? _c(
            "button",
            {
              staticClass: "c-action-buttons__button",
              class: { "is-loading": _vm.nextLoading },
              attrs: {
                disabled: _vm.nextDisabled,
                type: _vm.nextType,
                tabindex: _vm.nextDisabled ? -1 : 0
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleNextButtonClick()
                }
              }
            },
            [
              _vm._v("\n      \n      " + _vm._s(_vm.nextLabel) + "\n      "),
              _vm.nextLoading
                ? _c("div", { staticClass: "c-spinner" }, [
                    _c("div"),
                    _vm._v(" "),
                    _c("div"),
                    _vm._v(" "),
                    _c("div")
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d05923d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d05923d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/forms/action-buttons/ActionButtons.vue
// module id = 721
// module chunks = 0